import { appStorageApi } from "../../config/apiConfig";

import { StorageObjectValue } from "./types/service_types";
import {
  PostStorageObjectVersion,
  ResponseStorageObjectVersion,
  StorageObject,
  StorageObjectVersion,
} from "./types/object_types";

export const getAllStorageObjectVersions = <T extends StorageObjectValue>(
  id: string,
  service: string,
): Promise<StorageObjectVersion<T>[]> => {
  return appStorageApi.get(`objects_versions/${service}/${id}`).then((res) => {
    const dataWithoutJson: StorageObjectVersion<T>[] = res.data.map(
      (object: ResponseStorageObjectVersion) => {
        return {
          ...object,
          id: String(object.id),
          value: JSON.parse(object.value),
          version_id: String(object.version_id),
        };
      },
    );
    return dataWithoutJson;
  });
};

export const getStorageObjectVersion = <T extends StorageObjectValue>(
  id: string,
  versionId: string,
  service: string,
): Promise<StorageObjectVersion<T>> => {
  return appStorageApi
    .get(`objects_versions/${service}/${id}/${versionId}`)
    .then((res) => {
      const dataWithoutJson: StorageObject<T> = {
        ...res.data,
        id: String(res.data.id),
        value: JSON.parse(res.data.value),
        version_id: String(res.data.version_id),
      };
      return dataWithoutJson;
    });
};

export const createStorageObjectVersion = <T extends StorageObjectValue>(
  id: string,
  postObj: PostStorageObjectVersion,
  service: string,
): Promise<StorageObjectVersion<T>> => {
  return appStorageApi
    .post(`/objects_versions/${service}/${id}/version`, postObj)
    .then((res) => {
      return {
        ...res.data,
        value: JSON.parse(res.data.value),
        id: String(res.data.id),
        version_id: String(res.data.version_id),
      };
    });
};

export const updateStorageObjectVersion = <T extends StorageObjectValue>(
  storageObject: StorageObjectVersion<T>,
  service: string,
) => {
  const id = storageObject.id as string;
  const postObj: PostStorageObjectVersion = {
    version_name: storageObject.version_name as string,
    version_date: storageObject.version_date as string,
  };
  return appStorageApi
    .post(
      `/objects_versions/${service}/${id}/version/${storageObject.version_id}`,
      postObj,
    )
    .then((response) => response.data);
};

export const deleteStorageObjectVersion = <T extends StorageObjectValue>(
  id: string,
  versionId: string,
  service: string,
) => {
  return appStorageApi
    .delete(`/objects_versions/${service}/${id}/version/${versionId}`)
    .then((res) => res.data);
};
